var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

var RegisterThree = function (_Component) {
  _inherits(RegisterThree, _Component);

  function RegisterThree() {
    _classCallCheck(this, RegisterThree);

    var _this = _possibleConstructorReturn(this, (RegisterThree.__proto__ || Object.getPrototypeOf(RegisterThree)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSkip = _this.handleSkip.bind(_this);

    _this.state = {
      industry: "",
      industries: authDrawerConstants.INDUSTRIES,
      job_title: ""
    };
    return _this;
  }

  _createClass(RegisterThree, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;

      event.preventDefault();

      this.props.authDrawerActions.setOptionalInfo({
        industry: this.state.industry,
        job_title: this.state.job_title
      }).then(function () {
        _this2.props.authDrawerActions.registerEmail(_this2.props.authDrawer.userData).then(function () {
          _this2.props.authDrawerActions.toggleAuthDrawer(false);
        });
      });
    }
  }, {
    key: "handleSkip",
    value: function handleSkip() {
      var _this3 = this;

      return this.props.authDrawerActions.registerEmail(this.props.authDrawer.userData).then(function () {
        _this3.props.authDrawerActions.toggleAuthDrawer(false);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.container },
        React.createElement(
          "h3",
          null,
          "Thanks for signing up!"
        ),
        React.createElement(
          "div",
          { className: styles.marginTop20 },
          "In order to help us deliver news that will be most relevant to you, please tell us a little about yourself."
        ),
        React.createElement(
          "form",
          { onSubmit: this.handleSubmit },
          React.createElement(
            "div",
            { className: styles.marginTop40 },
            React.createElement(
              "select",
              { onChange: this.handleChange, name: "industry" },
              React.createElement(
                "option",
                null,
                "What industry do you work in?"
              ),
              this.state.industries.map(function (industry, index) {
                return React.createElement(
                  "option",
                  { key: index, value: industry },
                  industry
                );
              })
            )
          ),
          React.createElement(
            "div",
            { className: styles.marginTop20 },
            React.createElement("input", { onChange: this.handleChange, name: "job_title", type: "text", placeholder: "In what role?" })
          ),
          React.createElement(
            "div",
            { className: styles.nextButton },
            React.createElement(
              "button",
              { type: "submit", className: classNames(styles.blueButton1, styles.block, styles.centered) },
              "Finish"
            )
          )
        ),
        React.createElement(
          "div",
          { className: classNames(styles.marginTop20, styles.textCenter) },
          React.createElement(
            "button",
            { onClick: this.handleSkip, className: classNames(styles.blackLink, styles.bold, styles.skipButton) },
            "Skip for now"
          )
        )
      );
    }
  }]);

  return RegisterThree;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterThree);


// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/RegisterThree.js